<div class="range-input-container">
  <label class="range-control-label">Range customization</label>
  <div class="range-input-grid" [class.extended-padding]="gradientType !== Diverging">
    <span>Min</span>
    <mode-range-input-field
      label="min"
      [value]="min"
      [domainValue]="domainMin"
      [isDate]="isDate"
      [isBinned]="isBinned"
      (valueChanged)="onValueChanged($event, 'min')"
    >
    </mode-range-input-field>
    <ng-container *ngIf="gradientType === Diverging">
      <span>Midpoint</span>
      <mode-range-input-field
        label="mid"
        [value]="mid"
        [domainValue]="domainMidpoint"
        [isDate]="isDate"
        [isBinned]="isBinned"
        (valueChanged)="onValueChanged($event, 'mid')"
      >
      </mode-range-input-field>
    </ng-container>
    <span>Max</span>
    <mode-range-input-field
      label="max"
      [value]="max"
      [domainValue]="domainMax"
      [isDate]="isDate"
      [isBinned]="isBinned"
      (valueChanged)="onValueChanged($event, 'max')"
    >
    </mode-range-input-field>
  </div>
  <div
    class="range-msg"
    *ngIf="!isBinned && (!hasValidRange || !hasValidDomain)"
    [class.extra-height]="!hasValidDomain"
  >
    <div class="range-msg-container" [class.error]="!hasValidRange">
      <capra-icon icon="icon-warning" class="range-msg-icon"></capra-icon>
      <div [innerHTML]="statusMessage"></div>
    </div>
  </div>
</div>
